import ForgottenPasswordPage from 'Pages/ForgottenPasswordPage';
import LoginPage from 'Pages/LoginPage';
import MaintenancePage from 'Pages/MaintenancePage';
import NotAllowedPage from 'Pages/NotAllowedPage';
import NotFoundPage from 'Pages/NotFoundPage';
import PasswordRecoveryPage from 'Pages/PasswordRecoveryPage';
import SignInWithThirdPartyPage from 'Pages/SignInWithThirdPartyPage';
import WalletCardPage from 'Pages/WalletCardPage';
import AdminBookingStatsPage from 'Pages/Admin/AdminBookingStatsPage';
import NewCompanyPage from 'Pages/Creation/NewCompanyPage';
import NewCoworkingSpacePage from 'Pages/Creation/NewCoworkingSpacePage';
import NewDirectBookingPage from 'Pages/Creation/NewDirectBookingPage';
import NewDiscountCodePage from 'Pages/Creation/NewDiscountCodePage';
import NewEtablishmentPage from 'Pages/Creation/NewEtablishmentPage';
import NewModuleBookingPage from 'Pages/Creation/NewModuleBookingPage';
import NewNewsPage from 'Pages/Creation/NewNewsPage';
import NewPackOrderPage from 'Pages/Creation/NewPackOrderPage';
import NewPackPage from 'Pages/Creation/NewPackPage';
import NewPagePage from 'Pages/Creation/NewPagePage';
import NewServicePage from 'Pages/Creation/NewServicePage';
import NewServiceTitlePage from 'Pages/Creation/NewServiceTitlePage';
import NewSubscriptionPage from 'Pages/Creation/NewSubscriptionPage';
import NewUserPage from 'Pages/Creation/NewUserPage';
import AddBookingServicesPage from 'Pages/Front/AddBookingServicesPage';
import AllNewsPage from 'Pages/Front/AllNewsPage';
import CancelBookingPage from 'Pages/Front/CancelBookingPage';
import CancelBookingServicesPage from 'Pages/Front/CancelBookingServicesPage';
import CancelCompanyBookingPage from 'Pages/Front/CancelCompanyBookingPage';
import CGUPage from 'Pages/Front/CGUPage';
import CompanyCreateAccountPage from 'Pages/Front/CompanyCreateAccountPage';
import CompanyEmployeeLoginPage from 'Pages/Front/CompanyEmployeeLoginPage';
import CompanyLoginPage from 'Pages/Front/CompanyLoginPage';
import CompanyOfferPage from 'Pages/Front/CompanyOfferPage';
import ConceptPage from 'Pages/Front/ConceptPage';
import ContactPage from 'Pages/Front/ContactPage';
import CustomerAccountPage from 'Pages/Front/CustomerAccountPage';
import CustomerBookingsDashboardPage from 'Pages/Front/CustomerBookingsDashboardPage';
import CustomerInscriptionPage from 'Pages/Front/CustomerInscriptionPage';
import CustomerLoginPage from 'Pages/Front/CustomerLoginPage';
import DirectBookingPage from 'Pages/Front/DirectBookingPage';
import EmployeeBookingsDashboardPage from 'Pages/Front/EmployeeBookingsDashboardPage';
import EtablishmentsMapPage from 'Pages/Front/EtablishmentsMapPage';
import EtablishmentSubscriptionPage from 'Pages/Front/EtablishmentSubscriptionPage';
import FrontBookingPage from 'Pages/Front/FrontBookingPage';
import FrontEtablishmentPage from 'Pages/Front/FrontEtablishmentPage';
import FrontSpacePage from 'Pages/Front/FrontSpacePage';
import HomePage from 'Pages/Front/HomePage';
import IframeLoaderPage from 'Pages/Front/IframeLoaderPage';
import LegalPage from 'Pages/Front/LegalPage';
import LibConfirmationPage from 'Pages/Front/LibConfirmationPage';
import NewsPage from 'Pages/Front/NewsPage';
import PayBookingServicesPage from 'Pages/Front/PayBookingServicesPage';
import SearchResultsPage from 'Pages/Front/SearchResultsPage';
import RedirectCancelPage from 'Pages/iPage/RedirectCancelPage';
import RedirectFailurePage from 'Pages/iPage/RedirectFailurePage';
import RedirectOKPage from 'Pages/iPage/RedirectOKPage';
import AdminCompaniesDashboardPage from 'Pages/Lists/AdminCompaniesDashboardPage';
import AdminExportsOrderPage from 'Pages/Lists/AdminExportsOrderPage';
import AdminGlobalIndicatorPage from 'Pages/Lists/AdminGlobalIndicatorPage';
import AdminPackOrdersDashboardPage from 'Pages/Lists/AdminPackOrdersDashboardPage';
import AdminPackOrdersIndexDashboardPage from 'Pages/Lists/AdminPackOrdersIndexDashboardPage';
import ArrivalsDashboardPage from 'Pages/Lists/ArrivalsDashboardPage';
import B2BBookingsDashboardPage from 'Pages/Lists/B2BBookingsDashboardPage';
import BookingsDashboardPageV2 from 'Pages/Lists/BookingsDashboardPageV2';
import BookingsModuleDashboardPage from 'Pages/Lists/BookingsModuleDashboardPage';
import BuyPacksPage from 'Pages/Lists/BuyPacksPage';
import CompanyBookingsDashboardPage from 'Pages/Lists/CompanyBookingsDashboardPage';
import CoworkingSpacesDashboardPage from 'Pages/Lists/CoworkingSpacesDashboardPage';
import DiscountCodesDashboardPage from 'Pages/Lists/DiscountCodesDashboardPage';
import EtablishmentsDashboardPage from 'Pages/Lists/EtablishmentsDashboardPage';
import ExportHotelsDataPage from 'Pages/Lists/ExportHotelsDataPage';
import GlobalIndicatorPage from 'Pages/Lists/GlobalIndicatorPage';
import LoungeIndicatorPage from 'Pages/Lists/LoungeIndicatorPage';
import MeetingIndicatorPage from 'Pages/Lists/MeetingIndicatorPage';
import MyOrdersPage from 'Pages/Lists/MyOrdersPage';
import MyPacksPage from 'Pages/Lists/MyPacksPage';
import NewsDashboardPage from 'Pages/Lists/NewsDashboardPage';
import PacksDashboardPage from 'Pages/Lists/PacksDashboardPage';
import PagesDashboardPage from 'Pages/Lists/PagesDashboardPage';
import PriceConfigurationDashboardPage from 'Pages/Lists/PriceConfigurationDashboardPage';
import ScheduleConfigurationDashboardPage from 'Pages/Lists/ScheduleConfigurationDashboardPage';
import ScheduleDashboardPage from 'Pages/Lists/ScheduleDashboardPage';
import ServicesDashboardPage from 'Pages/Lists/ServicesDashboardPage';
import ServicesIndicatorPage from 'Pages/Lists/ServicesIndicatorPage';
import ServiceTitlesDashboardPage from 'Pages/Lists/ServiceTitlesDashboardPage';
import SubscriptionsDashboardPage from 'Pages/Lists/SubscriptionsDashboardPage';
import UsersDashboardPage from 'Pages/Lists/UsersDashboardPage';
import DiscountCodesIndicatorPage from 'Pages/Stats/DiscountCodesIndicatorPage';
import CompanyInformationPage from 'Pages/Update/CompanyInformationPage';
import UpdateCompanyPage from 'Pages/Update/UpdateCompanyPage';
import UpdateCoworkingSpacePage from 'Pages/Update/UpdateCoworkingSpacePage';
import UpdateDiscountCodePage from 'Pages/Update/UpdateDiscountCodePage';
import UpdateEtablishmentPage from 'Pages/Update/UpdateEtablishmentPage';
import UpdateNewsPage from 'Pages/Update/UpdateNewsPage';
import UpdatePackOrderIndexPage from 'Pages/Update/UpdatePackOrderIndexPage';
import UpdatePackPage from 'Pages/Update/UpdatePackPage';
import UpdatePagePage from 'Pages/Update/UpdatePagePage';
import UpdateServicePage from 'Pages/Update/UpdateServicePage';
import UpdateServiceTitlePage from 'Pages/Update/UpdateServiceTitlePage';
import UpdateUserPage from 'Pages/Update/UpdateUserPage';
export default {
  ForgottenPasswordPage: ForgottenPasswordPage,
  LoginPage: LoginPage,
  MaintenancePage: MaintenancePage,
  NotAllowedPage: NotAllowedPage,
  NotFoundPage: NotFoundPage,
  PasswordRecoveryPage: PasswordRecoveryPage,
  SignInWithThirdPartyPage: SignInWithThirdPartyPage,
  WalletCardPage: WalletCardPage,
  AdminBookingStatsPage: AdminBookingStatsPage,
  NewCompanyPage: NewCompanyPage,
  NewCoworkingSpacePage: NewCoworkingSpacePage,
  NewDirectBookingPage: NewDirectBookingPage,
  NewDiscountCodePage: NewDiscountCodePage,
  NewEtablishmentPage: NewEtablishmentPage,
  NewModuleBookingPage: NewModuleBookingPage,
  NewNewsPage: NewNewsPage,
  NewPackOrderPage: NewPackOrderPage,
  NewPackPage: NewPackPage,
  NewPagePage: NewPagePage,
  NewServicePage: NewServicePage,
  NewServiceTitlePage: NewServiceTitlePage,
  NewSubscriptionPage: NewSubscriptionPage,
  NewUserPage: NewUserPage,
  AddBookingServicesPage: AddBookingServicesPage,
  AllNewsPage: AllNewsPage,
  CancelBookingPage: CancelBookingPage,
  CancelBookingServicesPage: CancelBookingServicesPage,
  CancelCompanyBookingPage: CancelCompanyBookingPage,
  CGUPage: CGUPage,
  CompanyCreateAccountPage: CompanyCreateAccountPage,
  CompanyEmployeeLoginPage: CompanyEmployeeLoginPage,
  CompanyLoginPage: CompanyLoginPage,
  CompanyOfferPage: CompanyOfferPage,
  ConceptPage: ConceptPage,
  ContactPage: ContactPage,
  CustomerAccountPage: CustomerAccountPage,
  CustomerBookingsDashboardPage: CustomerBookingsDashboardPage,
  CustomerInscriptionPage: CustomerInscriptionPage,
  CustomerLoginPage: CustomerLoginPage,
  DirectBookingPage: DirectBookingPage,
  EmployeeBookingsDashboardPage: EmployeeBookingsDashboardPage,
  EtablishmentsMapPage: EtablishmentsMapPage,
  EtablishmentSubscriptionPage: EtablishmentSubscriptionPage,
  FrontBookingPage: FrontBookingPage,
  FrontEtablishmentPage: FrontEtablishmentPage,
  FrontSpacePage: FrontSpacePage,
  HomePage: HomePage,
  IframeLoaderPage: IframeLoaderPage,
  LegalPage: LegalPage,
  LibConfirmationPage: LibConfirmationPage,
  NewsPage: NewsPage,
  PayBookingServicesPage: PayBookingServicesPage,
  SearchResultsPage: SearchResultsPage,
  RedirectCancelPage: RedirectCancelPage,
  RedirectFailurePage: RedirectFailurePage,
  RedirectOKPage: RedirectOKPage,
  AdminCompaniesDashboardPage: AdminCompaniesDashboardPage,
  AdminExportsOrderPage: AdminExportsOrderPage,
  AdminGlobalIndicatorPage: AdminGlobalIndicatorPage,
  AdminPackOrdersDashboardPage: AdminPackOrdersDashboardPage,
  AdminPackOrdersIndexDashboardPage: AdminPackOrdersIndexDashboardPage,
  ArrivalsDashboardPage: ArrivalsDashboardPage,
  B2BBookingsDashboardPage: B2BBookingsDashboardPage,
  BookingsDashboardPageV2: BookingsDashboardPageV2,
  BookingsModuleDashboardPage: BookingsModuleDashboardPage,
  BuyPacksPage: BuyPacksPage,
  CompanyBookingsDashboardPage: CompanyBookingsDashboardPage,
  CoworkingSpacesDashboardPage: CoworkingSpacesDashboardPage,
  DiscountCodesDashboardPage: DiscountCodesDashboardPage,
  EtablishmentsDashboardPage: EtablishmentsDashboardPage,
  ExportHotelsDataPage: ExportHotelsDataPage,
  GlobalIndicatorPage: GlobalIndicatorPage,
  LoungeIndicatorPage: LoungeIndicatorPage,
  MeetingIndicatorPage: MeetingIndicatorPage,
  MyOrdersPage: MyOrdersPage,
  MyPacksPage: MyPacksPage,
  NewsDashboardPage: NewsDashboardPage,
  PacksDashboardPage: PacksDashboardPage,
  PagesDashboardPage: PagesDashboardPage,
  PriceConfigurationDashboardPage: PriceConfigurationDashboardPage,
  ScheduleConfigurationDashboardPage: ScheduleConfigurationDashboardPage,
  ScheduleDashboardPage: ScheduleDashboardPage,
  ServicesDashboardPage: ServicesDashboardPage,
  ServicesIndicatorPage: ServicesIndicatorPage,
  ServiceTitlesDashboardPage: ServiceTitlesDashboardPage,
  SubscriptionsDashboardPage: SubscriptionsDashboardPage,
  UsersDashboardPage: UsersDashboardPage,
  DiscountCodesIndicatorPage: DiscountCodesIndicatorPage,
  CompanyInformationPage: CompanyInformationPage,
  UpdateCompanyPage: UpdateCompanyPage,
  UpdateCoworkingSpacePage: UpdateCoworkingSpacePage,
  UpdateDiscountCodePage: UpdateDiscountCodePage,
  UpdateEtablishmentPage: UpdateEtablishmentPage,
  UpdateNewsPage: UpdateNewsPage,
  UpdatePackOrderIndexPage: UpdatePackOrderIndexPage,
  UpdatePackPage: UpdatePackPage,
  UpdatePagePage: UpdatePagePage,
  UpdateServicePage: UpdateServicePage,
  UpdateServiceTitlePage: UpdateServiceTitlePage,
  UpdateUserPage: UpdateUserPage
};
